import { render } from "./VerifyPremise.vue?vue&type=template&id=4d2a4210&scoped=true"
import script from "./VerifyPremise.vue?vue&type=script&lang=js"
export * from "./VerifyPremise.vue?vue&type=script&lang=js"

import "./VerifyPremise.vue?vue&type=style&index=0&id=4d2a4210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2a4210"]])

export default __exports__